document.addEventListener('DOMContentLoaded', function() {
    function checkForItemTitles() {
      var itemTitles = document.querySelectorAll('.gs__item-title');
  
      if (itemTitles.length > 0) {
        clearInterval(checkInterval);
        var coldPackagingExists = Array.from(itemTitles).some(function(item) {
          return item.textContent.includes("Keep Cool- Insulated Cold Packaging");
        });
  
        if (coldPackagingExists) {
          var gsFieldsElements = document.querySelectorAll('.gs__fields');
  
          gsFieldsElements.forEach(function(element, index) {
            var messageParagraph = document.createElement('p');
            messageParagraph.textContent = "For the Keep Cool- Insulated Cold Packaging fee please select the address the chocolate products are associated with.";
  
            if (index === 0) {
              messageParagraph.id = 'multi_address_chocolate';
            } else {
              messageParagraph.classList.add('multi_address_chocolate');
            }
  
            element.parentNode.insertBefore(messageParagraph, element.nextSibling);
          });
        }
      }
    }
  
    var checkInterval = setInterval(checkForItemTitles, 500);
  
    setTimeout(function() {
      clearInterval(checkInterval);
    }, 5000);
  });
  
  jQuery(document).ready(function(){
    $('.qtybox .btnqty').on('click', function(){
      var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
      if($(this).hasClass('qtyplus')) {
        qty++;
      }else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty))?1:qty;
      $(this).parent('.qtybox').find('.quantity-input').val(qty);
    }); 
  });